import { parseJsonField } from "../../utils/parseJsonField";
import "../../css/pageLayout.css"

function HeroSection({ section }) {
  const settings = parseJsonField(section.settings_json);

  return (
    <section className={`hero-section hero-${settings.variant || "default"}`}>
      <div className={`hero-content align-${settings.alignment || "center"}`}>
        {settings.title && <h1>{settings.title}</h1>}
        {settings.subtitle && <p>{settings.subtitle}</p>}

        {settings.button_text && settings.button_url && (
          <a href={settings.button_url} className="hero-button">
            {settings.button_text}
          </a>
        )}
      </div>
    </section>
  );
}

export default HeroSection;